import type { ReactNode } from 'react'

/** Adapted GXLabs SectionHeading: tick, kicker, uppercase light title (left-aligned for app pages). */
export function PageHeader({
  kicker,
  title,
  lead,
  actions,
}: {
  kicker?: string
  title: ReactNode
  lead?: ReactNode
  actions?: ReactNode
}) {
  return (
    <header className="page-header">
      <div>
        {kicker && <p className="page-header__kicker">{kicker}</p>}
        <h1 className="page-header__title">{title}</h1>
        {lead && <p className="page-header__lead">{lead}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  )
}
